import gql from "graphql-tag";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    extraInfoQueryType,
    updateExtraInfoType,
} from "./__graphql-types__/index.ts";

export const UPDATE_EXTRA_INFO: GqlOperation<
    updateExtraInfoType["response"],
    updateExtraInfoType["variables"]
> = gqlOp(gql`
    mutation updateExtraInfo($nickname: String, $birthday: String) {
        setSettings(nickname: $nickname, birthdate: $birthday) {
            errors {
                code
            }
        }
    }
`);

export const GET_EXTRA_INFO: GqlOperation<
    extraInfoQueryType["response"],
    extraInfoQueryType["variables"]
> = gqlOp(gql`
    query extraInfoQuery {
        user {
            id
            nickname
            email
            birthMonthYear
            tosForFormalTeacherStatus
        }
    }
`);

export interface ExtraInfo {
    nickname: string;
    birthday: string;
    tosForFormalTeacherStatus: boolean;
    email: string;
}

export function mapQueryResultToInitialValues(
    result: Result<extraInfoQueryType["response"]>,
): ExtraInfo {
    if (result.status !== "success") {
        return {
            nickname: "",
            birthday: "",
            email: "",
            tosForFormalTeacherStatus: false,
        };
    }

    const {user} = result.data;
    return {
        nickname: user?.nickname ?? "",
        birthday: user?.birthMonthYear ? `${user?.birthMonthYear}-01` : "",
        email: user?.email ?? "",
        tosForFormalTeacherStatus: !!user?.tosForFormalTeacherStatus,
    };
}
